import React, { useRef, useState } from 'react'
import { Carousel } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Go to the <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>'Play Store'</p>.</div>"
      ),
      img: '/images/android/three/1.png'
    }
  ]

  const imgToggle = useRef()

  const [currentSlide, setcurrentSlide] = useState(0)

  const onChange = currentSlide1 => {
    setcurrentSlide(currentSlide1)
  }

  const Handler = index => {
    if (index !== 6) {
      imgToggle.current.goTo(index)
    } else {
      imgToggle.current.goTo(0)
    }
  }

  const [autoplay, setAutoplay] = useState(true)

  return (
    <div
      className={`w-[620px] Ssm:w-[100%] mx-auto justify-between overflow-x-hidden overflow-auto setup ${data.fullScreen ? 'flex xs:pb-[20px] justify-center' : ' Smd:flex xs:pb-[30px] h-[99%]'
        }`}
    >
      {data.fullScreen && (
        <Icon
          onClick={() => {
            data.setFullScreen(false)
          }}
          icon='maki:cross'
          className={` absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
        />
      )}

      <div
        onMouseEnter={() => {
          setAutoplay(false)
        }}
        onMouseLeave={() => {
          setAutoplay(true)
        }}
        className={`Ssm:w-[100%] w-full mx-auto setup ${data.fullScreen ? 'grid mx-auto justify-center' : ' Smd:flex Dsm:mt-[80px] Dsm:xs:mt-[30px] justify-between'
          }`}
      >
        <div className={`w-[343px] ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'}`}>
          <p
            className={`text-[24px] Dsm:text-[20px] pb-[10px] Dsm:mt-[20px] font-[600] text-center Smd:text-left  text-black ${data.fullScreen ? 'hidden' : ''
              }`}
          >
            {t('Install Msafely')}
          </p>
          <div className={`${data.fullScreen ? 'pt-[15px]' : 'Dsm:pt-[20px] Dsm:w-[96%] mx-auto'}`}>
            <p className='text-[#222] text-[13px] mt-3 Ssm:text-center'>{t('Enter the registration code')}:</p>
            <p className='text-[#2ECC71] text-[42px] font-[700] mt-3  Ssm:text-center'>{data.Code}</p>
            <p className='text-[#222] text-[13px] mt-3 Ssm:text-center'>
              {t('Follow the instructions you see on the target Android phone')}
            </p>
          </div>
        </div>
        <div
          className={`w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
            }`}
        >
          <Carousel
            autoplay={autoplay}
            className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
            ref={imgToggle}
            cancelable={false}
            afterChange={onChange}
          >
            {step.map((item, index) => {
              return (
                <div key={index} className=' rounded-[15px]'>
                  <Image
                    alt='img'
                    width={100}
                    height={100}
                    src={item.img}
                    className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                  />
                </div>
              )
            })}
          </Carousel>
          <div className='flex items-center justify-center mt-5'>
            {step.map((item, index) => {
              return (
                <div
                  onClick={() => Handler(index)}
                  key={index}
                  className={`border-[1px] ml-2 border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#12D8AB]'
                    } `}
                ></div>
              )
            })}
          </div>
          <div className='absolute -left-[3px] top-[55px]'>
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
          </div>
        </div>
      </div>

      <div className={`Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
        <Image
          src='/images/android/watch.png'
          width={100}
          height={100}
          alt='watch'
          className='mx-auto w-[150px] mt-[20px]'
        />
      </div>
    </div>
  )
}

export default One
